module.exports = __webpack_public_path__ + "Lato-Light.b60339d97bb696503035.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Light.ttf
// module id = ../../../../../src/assets/fonts/Lato-Light.ttf
// module chunks = styles